import React, { createContext, useContext, useEffect, useState } from 'react';
import { getMyHighestPriviledgeRole, getMyRole } from '../../Services/PtaasApiService';
import { useMsal } from '@azure/msal-react';
import MyApplicationRole from '../../Models/MyApplicationRole';


interface UserContextType {
  highestPrivilegeRole: string | null;
  isLoading: boolean;
  // Null until the roles have loaded — the type now reflects that so consumers
  // are steered toward the optional-chaining they already rely on.
  myApplicationRole: MyApplicationRole[] | null;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { instance, accounts } = useMsal();
  const [highestPrivilegeRole, setHighestPrivilegeRole] = useState<string | null>(null);
 const [myApplicationRole, setMyApplicationRole] = useState<MyApplicationRole[] | null>(null);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUserRole = async () => {
      if (accounts && accounts[0]) {
        try {
          // The highest-privilege role and the per-project roles are independent
          // reads, so fetch them together instead of one-after-the-other.
          const [role, Role] = await Promise.all([
            getMyHighestPriviledgeRole(instance, accounts[0]),
            getMyRole(instance, accounts[0]),
          ]);
          setHighestPrivilegeRole(role);
          setMyApplicationRole(Role);
        } catch (error) {
          console.error('Failed to fetch user role:', error);
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchUserRole();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accounts[0]?.homeAccountId, instance]);

  return (
    <UserContext.Provider value={{ highestPrivilegeRole, isLoading, myApplicationRole }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within UserProvider');
  }
  return context;
};